import React from 'react';
import PropTypes from 'prop-types';
import Header from './Header';

const Layout = ({ title, children }) => (
  <div>
    <Header title={title} />
    <div className="c-wrapper o-page-height medium-and-down-p-- c-wrapper-allow-header">
      {children}
    </div>
  </div>
);
Layout.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Layout;
